module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-bold-web.eot?a3eecce78ad90daa542d5e518592f17e";